import React from 'react';

const HeroSection = () => {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-primary-900 overflow-hidden pt-20">
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Welcome Section */}
        <div className="mb-8">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight">
            Revoluciona
          </h1>
          
          <div className="text-6xl md:text-8xl font-black">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-red-500 to-orange-600">
              tu restaurante
            </span>
          </div>
        </div>

        {/* Subtitle */}
        <div className="mb-12">
          <div className="space-y-6">
            <div className="inline-flex items-center bg-orange-500/20 backdrop-blur-sm text-orange-300 px-6 py-3 rounded-full shadow-lg border border-orange-500/30">
              <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              <span className="font-semibold text-lg">Sistema para restaurantes</span>
            </div>
            
            <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
              Sistema completo de gestión que automatiza pedidos. Todo lo que necesitas 
              para hacer crecer tu negocio.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://demo.pidemelo.mx/"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center px-10 py-4 bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold text-lg rounded-2xl hover:from-orange-600 hover:to-red-700 transform hover:scale-105 transition-all duration-300 shadow-2xl"
              >
                <svg className="w-6 h-6 mr-3 group-hover:rotate-12 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
                Ver Demo en Vivo
                <div className="absolute inset-0 bg-white/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </a>

              <button
                onClick={() => document.getElementById('caracteristicas').scrollIntoView({ behavior: 'smooth' })}
                className="inline-block bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-2xl font-semibold text-lg border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-300"
              >
                Conocer más
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
